import type { GetAuthTokenCache, YammerCache } from '../cache';
import { getTokenCacheTimeToLive } from '../cache';
import type { Authenticator } from '../types';
import { AuthenticatorType } from '../types';

import { getAuthToken } from './getAuthToken';

export default class TeamsAuthenticator implements Authenticator {
  public readonly type: AuthenticatorType = AuthenticatorType.Teams;
  protected readonly authTokenCache: YammerCache | undefined;

  constructor(getAuthTokenCache: GetAuthTokenCache) {
    this.authTokenCache = getAuthTokenCache();
  }

  public acquireToken = async (
    [resource]: string[],
    claims?: string,
    tenantId?: string,
    silent?: boolean
  ): Promise<string> => {
    if (!claims && !tenantId) {
      const cachedToken = await this.getTokenFromCache(resource);
      if (cachedToken) {
        return cachedToken;
      }
    }

    const token = await this.getToken(resource, claims ? [claims] : undefined, tenantId, silent);

    if (!claims && !tenantId) {
      await this.addTokenToCache(resource, token);
    }

    return token;
  };

  public getToken = (resource: string, claims?: string[], tenantId?: string, silent?: boolean): Promise<string> =>
    getAuthToken({ resource, claims, tenantId, silent });

  public addTokenToCache = async (resource: string, token: string): Promise<void> => {
    const ttl = getTokenCacheTimeToLive(token);
    if (ttl && this.authTokenCache) {
      await this.authTokenCache.setItem(resource, token, ttl);
    }
  };

  public getTokenFromCache = async (resource: string): Promise<string | null> => {
    if (this.authTokenCache) {
      return await this.authTokenCache.getItem<string>(resource);
    }

    return null;
  };

  public acquireTokenRedirect() {
    throw new Error('acquireTokenRedirect is not implemented');
  }

  public setThirdPartyCookieErrorCallback() {
    throw new Error('setThirdPartyCookieErrorCallback is not implemented');
  }
}
